const detectOperatorPrefix = (operatorTokens) => {
  if (!operatorTokens.length) {
    return '';
  }

  const prefixes = operatorTokens.map((token) => token.match(/^[^a-zA-Z0-9]+/)?.[0] || '');
  const nonEmptyPrefixes = prefixes.filter(Boolean);

  if (!nonEmptyPrefixes.length) {
    return '';
  }

  const firstPrefix = nonEmptyPrefixes[0];

  return nonEmptyPrefixes.every((prefix) => prefix === firstPrefix) ? firstPrefix : '';
};

export default detectOperatorPrefix;
